const IMAGE_MIME_TYPE_LABELS: Readonly<Record<string, string>> = {
  'image/jpeg': 'JPG',
  'image/png': 'PNG',
  'image/webp': 'WebP',
  'image/heic': 'HEIC',
  'image/heif': 'HEIF',
};

const labelFor = (mimeType: string): string => IMAGE_MIME_TYPE_LABELS[mimeType] ?? mimeType;

/** `['image/jpeg', 'image/png', 'image/webp']` → `JPG, PNG, or WebP`. */
export const formatImageMimeTypes = (mimeTypes: readonly string[]): string => {
  const labels = mimeTypes.map(labelFor);
  if (labels.length <= 1) {
    return labels.join('');
  }
  const head = labels.slice(0, -1).join(', ');
  const tail = labels[labels.length - 1];
  return `${head}, or ${tail}`;
};
